<section class="admin-page ct-page">
  <div class="ct-toolbar">
    <div>
      <p class="subtitle">{{ 'brands.subtitle' | t }}</p>
    </div>
    <button class="ct-btn ct-btn-primary" type="button" (click)="openCreate()">
      {{ 'brands.new' | t }}
    </button>
  </div>

  <div class="ct-card ct-table-wrap">
    <table class="ct-table">
      <thead>
        <tr>
          <th class="col-logo">{{ 'brands.logo' | t }}</th>
          <th>{{ 'common.name' | t }}</th>
          <th class="col-status">{{ 'common.status' | t }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @if (loading()) {
          <tr><td colspan="4">{{ 'common.loading' | t }}</td></tr>
        } @else if (items().length === 0) {
          <tr><td colspan="4">{{ 'brands.empty' | t }}</td></tr>
        } @else {
          @for (item of items(); track item.id) {
            <tr>
              <td class="col-logo">
                @if (item.logoUrl) {
                  <img class="logo-thumb" [src]="item.logoUrl" [alt]="item.name" appImgFallback />
                } @else {
                  <span class="logo-empty">—</span>
                }
              </td>
              <td>{{ item.name }}</td>
              <td class="col-status">
                <span class="ct-badge" [class.ct-badge-success]="item.isActive" [class.ct-badge-muted]="!item.isActive">
                  {{ (item.isActive ? 'common.active' : 'common.inactive') | t }}
                </span>
              </td>
              <td class="actions">
                <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="openEdit(item)">
                  {{ 'common.edit' | t }}
                </button>
                <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="remove(item)">
                  {{ 'common.delete' | t }}
                </button>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</section>

@if (dialogOpen()) {
  <div class="ct-dialog-backdrop" (click)="closeDialog()">
    <div class="ct-dialog wide" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <header class="ct-dialog-head"><h2>{{ (editingId() ? 'brands.edit' : 'brands.new') | t }}</h2>        <button type="button" class="ct-dialog-close" (click)="closeDialog()" [attr.aria-label]="'common.close' | t">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button></header>
      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="ct-dialog-body">
        <div class="ct-form-grid">
          <div class="ct-field full">
            <label for="name">{{ 'common.name' | t }}</label>
            <input id="name" class="ct-input" formControlName="name" />
          </div>
          <div class="ct-field full">
            <label>{{ 'brands.logo' | t }} <span class="optional">{{ 'brands.logoOptional' | t }}</span></label>
            <p class="hint">{{ 'brands.logoHint' | t }}</p>
            @if (logoPreview()) {
              <img class="logo-preview" [src]="logoPreview()!" alt="" />
            }
            <div class="file-picker">
              <input
                #logoInput
                class="file-input"
                type="file"
                accept="image/jpeg,image/png,image/webp,image/gif,image/svg+xml"
                (change)="onLogoSelected($event)"
              />
              <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="logoInput.click()">
                <span class="material-symbols-outlined">image</span>
                {{ 'brands.chooseLogo' | t }}
              </button>
              @if (logoPreview()) {
                <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="clearLogo()">
                  {{ 'brands.removeLogo' | t }}
                </button>
              }
            </div>
          </div>
          <div class="ct-field full">
            <label>
              <input type="checkbox" formControlName="isActive" /> {{ 'common.active' | t }}
            </label>
          </div>
        </div>
        </div>
        <div class="ct-dialog-actions">
          <button class="ct-btn ct-btn-ghost" type="button" (click)="closeDialog()">
            {{ 'common.cancel' | t }}
          </button>
          <button class="ct-btn ct-btn-primary" type="submit">{{ 'common.save' | t }}</button>
        </div>
      </form>
    </div>
  </div>
}
